import { entryCards } from "@/mocks/navData";

const QUICK_META = [
  { k: "更新节奏", v: "滚动刷新" },
  { k: "直达条数", v: "1200+" },
  { k: "覆盖分区", v: "四大类" },
  { k: "重复搜索", v: "归零" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      {/* decorative warm wash */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-[#f3e4cb] via-[#faf5ec] to-[#faf5ec]"></div>
      <div className="pointer-events-none absolute -right-24 -top-20 h-80 w-80 rounded-full bg-[#e8c99b]/40 blur-3xl"></div>
      <div className="pointer-events-none absolute -left-24 top-40 h-72 w-72 rounded-full bg-[#eaa983]/30 blur-3xl"></div>

      <div className="relative mx-auto w-full max-w-[1240px] px-4 pb-6 pt-10 md:px-6 md:pt-14">
        {/* intro band */}
        <div className="flex flex-col items-start justify-between gap-10 lg:flex-row lg:items-end">
          <div className="max-w-3xl">
            <p className="mb-4 inline-flex items-center gap-2 rounded-full bg-[#f6e3cd] px-3 py-1 text-xs font-semibold text-[#b07a1f]">
              <i className="ri-flashlight-line text-sm"></i>
              吃瓜地址一键直达 · 快速导航 · 跳转短链
            </p>
            <h1 className="text-4xl font-bold leading-[1.12] tracking-tight text-[#2a2016] md:text-5xl">
              想看的入口，
              <br className="hidden sm:block" />
              一次摆到你<b className="text-[#e4562b]">跟前</b>。
            </h1>
            <p className="mt-5 max-w-xl text-[15px] leading-relaxed text-[#6b5d48]">
              把散在各处的热门地址收成一张直达地图：标题即入口，短链更好记。
              不再反复搜索、来回粘贴，点开即用，随时找瓜看料都省心。
            </p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#index"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-[#e4562b] px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#c8421c]"
              >
                进入编号合集
                <i className="ri-arrow-right-line text-base"></i>
              </a>
              <a
                href="#tags"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full border border-[#d8c3a0] px-6 py-3 text-sm font-medium text-[#4c4132] transition-colors hover:border-[#e4562b] hover:text-[#e4562b]"
              >
                先逛话题标签
              </a>
            </div>
          </div>

          {/* quick meta panel */}
          <div className="w-full max-w-[280px] shrink-0 rounded-2xl border border-[#ead9bd] bg-[#fffdf8] p-5">
            <p className="mb-4 flex items-center justify-between text-sm font-semibold text-[#2a2016]">
              今日速览
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#e4562b]/10 text-[#e4562b]">
                <i className="ri-fire-line text-sm"></i>
              </span>
            </p>
            <dl className="space-y-3">
              {QUICK_META.map((m) => (
                <div
                  key={m.k}
                  className="flex items-center justify-between border-b border-dashed border-[#ead9bd] pb-3 last:border-0 last:pb-0"
                >
                  <dt className="text-xs text-[#8a7c64]">{m.k}</dt>
                  <dd className="text-sm font-bold text-[#2a2016]">{m.v}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>

        {/* parallel entry cards */}
        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 md:mt-12 lg:grid-cols-4">
          {entryCards.map((card) => (
            <a
              key={card.id}
              href="#index"
              className="group flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-[#ead9bd] bg-[#fffdf8] transition-all duration-300 hover:-translate-y-1 hover:border-[#e9b98a]"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={card.cover}
                  alt={card.title}
                  title={card.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-[#2a2016]/70 px-3 py-1 text-xs font-medium text-white backdrop-blur">
                  {card.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="text-base font-bold text-[#2a2016]">{card.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-[#8a7c64]">{card.desc}</p>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-xs text-[#b0843f]">{card.stat}</span>
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#f0e3cd] text-[#b0843f] transition-colors group-hover:bg-[#e4562b] group-hover:text-white">
                    <i className="ri-arrow-right-up-line text-sm"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}